/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Sampling_FastInputs */



/**
* | output |
* | --- |
* | "2s (Fast)" |
*
* @param {Ocr_Sampling_FastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_sampling_fast = /** @type {((inputs?: Ocr_Sampling_FastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Sampling_FastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("2s (Rapide)")
	if (locale === "de") return /** @type {LocalizedString} */ ("2s (Schnell)")
	if (locale === "it") return /** @type {LocalizedString} */ ("2 secondi (veloce)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("2 с (быстро)")
	if (locale === "es") return /** @type {LocalizedString} */ ("2s (Rápido)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("2秒（快）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("2秒（高速）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("2 सेकंड (तेज़)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("2s (Rápido)")
	return /** @type {LocalizedString} */ ("2s (Fast)")
});